import { api } from "@/lib/api";

export const AttendanceAPI = {
  createSession: (body) => api.post("/attendance/sessions", body).then((r) => r.data),
  listSessions: (params) => api.get("/attendance/sessions", { params }).then((r) => r.data),
  getSession: (id) => api.get(`/attendance/sessions/${id}`).then((r) => r.data),
  mark: (id, records, source = "manual") =>
    api.post(`/attendance/sessions/${id}/mark`, { records, source }).then((r) => r.data),
  close: (id) => api.post(`/attendance/sessions/${id}/close`).then((r) => r.data),
  reopen: (id) => api.post(`/attendance/sessions/${id}/reopen`).then((r) => r.data),
  issueQr: (id) => api.post(`/attendance/sessions/${id}/qr`).then((r) => r.data),
  qrCheckin: (token, student_id) =>
    api.post("/attendance/qr/checkin", { token, student_id }).then((r) => r.data),
  studentSummary: (id, params) => api.get(`/attendance/students/${id}/summary`, { params }).then((r) => r.data),
  classReport: (id, params) => api.get(`/attendance/reports/class/${id}`, { params }).then((r) => r.data),
  listRegs: (params) => api.get("/attendance/regularisations", { params }).then((r) => r.data),
  createReg: (body) => api.post("/attendance/regularisations", body).then((r) => r.data),
  decideReg: (id, decision, notes) =>
    api.post(`/attendance/regularisations/${id}/decide`, { decision, notes }).then((r) => r.data),
  subjectSummary: (classId, params) =>
    api.get(`/attendance/class/${classId}/subject-summary`, { params }).then((r) => r.data),
};

export const SubjectsAPI = {
  list: (params) => api.get("/subjects", { params }).then((r) => r.data),
  templates: () => api.get("/subjects/templates").then((r) => r.data),
  autoGenerate: (params) => api.post("/subjects/auto-generate", null, { params }).then((r) => r.data),
};

export const ATTENDANCE_STATUSES = ["present", "absent", "late", "excused"];
